/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-trigger.js
 *
 * 指定クラスの位置までスクロールして,実行するアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import scrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(scrollTrigger);

//定義
let speed = 0.9;
const Trigger = document.querySelectorAll(".trigger");
const scrubTrigger = document.querySelectorAll(".scrubTrigger");
const Fadein = document.querySelectorAll(".fadein");
const FadeinTrain = document.querySelectorAll(".fadein__train");
const SlideLeft = document.querySelectorAll(".slide__left");
const SlideUpTrain = document.querySelectorAll(".slide__up__train");
const clipPathLeft = document.querySelectorAll(".clipPathLeft");
const FadeinTrainText = document.querySelectorAll(".fadein__train__text");
const FadeinTrainLabel = document.querySelectorAll(".fadein__train__label");
/**
 * set（対象が存在するときだけ）
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
if (Fadein.length) {
	gsap.set(Fadein, {
		opacity: 0,
	});
}
if (FadeinTrain.length) {
	gsap.set(FadeinTrain, {
		opacity: 0,
	});
}
if (SlideUpTrain.length) {
	gsap.set(SlideUpTrain, {
		yPercent: 50,
		opacity: 0,
	});
}
if (SlideLeft.length) {
	gsap.set(SlideLeft, {
		width: "0%", // 初期幅を0%に設定
		opacity: 0,
	});
}
if (clipPathLeft.length) {
	gsap.set(clipPathLeft, {
		clipPath: "inset(0 100% 0 0)",
		// opacity: 0,
	});
}
if (FadeinTrainText.length) {
	gsap.set(FadeinTrainText, {
		clipPath: "inset(100% 0 0 0)", // 初期状態で完全に隠す
		yPercent: 50,
		opacity: 0,
	});
}
if (FadeinTrainLabel.length) {
	gsap.set(FadeinTrainLabel, {
		yPercent: 20,
		opacity: 0,
	});
}

/**
 * Trigger
 * 指定クラスの位置までスクロールして,実行する
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setTrigger = () => {
	for (let i = 0; i < Trigger.length; i++) {
		const timeline = gsap.timeline({
			scrollTrigger: {
				trigger: Trigger[i], // トリガー要素
				start: "top 70%", // アニメーション開始位置
				toggleActions: "play none none reverse", // トリガーアクション
				// markers: true, // デバッグ用マーカー
			},
		});

		// タイムラインにアニメーションを追加
		timeline
			.to(Trigger[i].querySelectorAll(".fadein__train__text"), {
				clipPath: "inset(0 0 0 0)", // マスクを外す
				opacity: 1,
				yPercent: 0,
				duration: speed,
				stagger: {
					from: "start", // アニメーションの開始位置
					amount: 1.0, // 全体のアニメーション時間を分割
				},
			})
			.to(
				Trigger[i].querySelectorAll(".fadein__train__label"),
				{
					yPercent: 0,
					opacity: 1,
					duration: speed,
					stagger: {
						from: "start",
						amount: 1.0, // 全体のアニメーション時間を分割
					},
				},
				"-=0.5" // 前のアニメーションと0.5秒重ねる
			);
		gsap.to(Trigger[i].querySelectorAll(".fadein"), {
			opacity: 1,
			duration: speed,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 75%",
				toggleActions: "play none none none",
				// markers: true,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".fadein__train"), {
			opacity: 1,
			duration: speed,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 70%",
				toggleActions: "play none none reverse",
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.7,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".slide__up__train"), {
			opacity: 1,
			yPercent: 0,
			duration: speed,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 75%",
				toggleActions: "play none none none",
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.7,
			},
		});
	}
	for (let i = 0; i < clipPathLeft.length; i++) {
		gsap.to(clipPathLeft[i], {
			opacity: 1,
			clipPath: "inset(0)",
			duration: speed,
			scrollTrigger: {
				trigger: clipPathLeft[i],
				start: "top 50%",
				toggleActions: "play none none reverse",
				// markers: true,
			},
		});
	}

	const bgSec = document.querySelectorAll(".bg-sec");
	bgSec.forEach((el) => {
		let color = el.dataset.color;
		gsap.to(el, {
			backgroundColor: color,
			scrollTrigger: {
				trigger: el,
				start: "top 50%",
				toggleActions: "play none none reverse",
				// markers: true,
			},
		});
	});
	const bgSecMask = document.querySelectorAll(".bg-sec-mask");
	bgSecMask.forEach((el) => {
		let color = el.dataset.color;
		gsap.to(el, {
			backgroundColor: color,
			scrollTrigger: {
				trigger: bgSec,
				start: "top 50%",
				toggleActions: "play none none reverse",
				// markers: true,
			},
		});
	});
	const bgSecLink = document.querySelectorAll(".t-gallery .post-list .link");
	bgSecLink.forEach((el) => {
		gsap.to(el, {
			color: "#fff",
			scrollTrigger: {
				trigger: bgSec,
				start: "top 50%",
				toggleActions: "play none none reverse",
				// markers: true,
			},
		});
	});

	const addFixed = document.getElementById("addFixed");
	const addFixedSp = document.getElementById("addFixedSp");
	const DNavBtn = document.getElementById("d-nav-btn");

	scrollTrigger.matchMedia({
		// 761px以上の場合
		"(min-width: 761px)": function () {
			scrollTrigger.create({
				trigger: addFixed,
				start: "top top", // トリガーが画面の上部に来たとき
				onEnter: () => DNavBtn.classList.add("btnFixed"),
				onLeaveBack: () => DNavBtn.classList.remove("btnFixed"),
			});
		},
		// 760px未満の場合
		"(max-width: 760px)": function () {
			scrollTrigger.create({
				trigger: addFixedSp,
				start: "top top", // トリガーが画面の上部に来たとき
				onEnter: () => DNavBtn.classList.add("btnFixed"),
				onLeaveBack: () => DNavBtn.classList.remove("btnFixed"),
			});
		},
	});

	const navFixedTrigger = document.getElementById("navFixedTrigger");
	const navFixed = document.getElementById("navFixed");
	if (navFixedTrigger) {
		scrollTrigger.create({
			trigger: navFixedTrigger,
			start: "top top", // トリガーが画面の上部に来たとき
			// endTrigger: "#cta", // 特定のIDを指定
			// end: "top center", // トリガーが画面の中央に来たとき
			onEnter: () => navFixed.classList.add("transformNav"),
			onLeaveBack: () => navFixed.classList.remove("transformNav"),
			// onEnterBack: () => navFixed.classList.add("transformNav"),
			// onLeave: () => navFixed.classList.remove("transformNav"),
			// markers: true,
		});
	}

	// scrollTrigger.matchMedia({
	// 	// 761px以上の場合
	// 	"(min-width: 761px)": function () {},
	// 	// 760px未満の場合
	// 	"(max-width: 760px)": function () {
	// 		scrollTrigger.create({
	// 			trigger: navFixedTrigger,
	// 			start: "top top", // トリガーが画面の上部に来たとき
	// 			onEnter: () => navFixed.classList.add("transformNav"),
	// 			onLeaveBack: () => navFixed.classList.remove("transformNav"),
	// 		});
	// 	},
	// });
};

/**
 * scrubTrigger
 * 指定クラスの位置からスクロール量で実行する
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setScrubTrigger = () => {
	for (let i = 0; i < scrubTrigger.length; i++) {
		gsap.to(scrubTrigger[i].querySelectorAll(".img .cover"), {
			scaleY: 0,
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: "top 75%",
				end: "40% 75%",
				scrub: 1,
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.2,
			},
		});
		gsap.to(scrubTrigger[i].querySelectorAll(".movie .cover"), {
			scale: 1,
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: "top 75%",
				end: "40% 75%",
				scrub: 1,
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.2,
			},
		});
		gsap.to(scrubTrigger[i].querySelectorAll(".block__schedule .cover"), {
			opacity: 0.8,
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: "top 75%",
				end: "bottom 75%",
				scrub: 1,
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.2,
			},
		});
		if (window.matchMedia("(min-width: 600px)").matches) {
			var startPotision = "40% 75%";
		} else {
			var startPotision = "top 75%";
		}
		gsap.to(scrubTrigger[i].querySelectorAll(".headline .span__create > span"), {
			translateY: 0,
			opacity: 1,
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: startPotision,
				end: "80% 75%",
				scrub: 1,
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.5,
			},
		});
		gsap.to(scrubTrigger[i].querySelectorAll(".scaleDown"), {
			scale: 1,
			opacity: 1,
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: "30% 75%",
				end: "80% 75%",
				scrub: 1,
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.2,
			},
		});
	}
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setTrigger, setScrubTrigger };
